import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../api/axios';
import Gantt from 'frappe-gantt';

export default function AdminGantt() {
  const ganttRef = useRef(null);
  const ganttInstance = useRef(null);
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filterProject, setFilterProject] = useState('');
  const [viewMode, setViewMode] = useState('Week');
  const [loading, setLoading] = useState(true);

  const PRIORITY_COLORS = { kritik: '#ef4444', yuksek: '#f97316', normal: '#007aff', dusuk: '#9ca3af' };

  useEffect(() => {
    api.get('/tasks/projects').then(r => setProjects(r.data));
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();
    if (filterProject) params.append('project_id', filterProject);
    api.get('/tasks/tasks?' + params.toString()).then(r => {
      setTasks(r.data);
      setLoading(false);
    });
  }, [filterProject]);

  useEffect(() => {
    if (!ganttRef.current || loading) return;

    const validTasks = tasks.filter(t => t.start_date && t.due_date);
    if (validTasks.length === 0) return;

    const ganttTasks = validTasks.map(t => ({
      id: t.id,
      name: t.title,
      start: t.start_date.substring(0, 10),
      end: t.due_date.substring(0, 10),
      progress: t.progress || 0,
      custom_class: `priority-${t.priority}`,
    }));

    // Eski instance'ı temizle
    if (ganttRef.current) ganttRef.current.innerHTML = '';

    ganttInstance.current = new Gantt(ganttRef.current, ganttTasks, {
      view_mode: viewMode,
      language: 'tr',
      on_click: (task) => {},
      on_date_change: async (task, start, end) => {
        await api.put('/tasks/tasks/' + task.id, {
          ...tasks.find(t => t.id === task.id),
          start_date: start.toISOString().substring(0, 10),
          due_date: end.toISOString().substring(0, 10),
        });
      },
      on_progress_change: async (task, progress) => {
        const t = tasks.find(x => x.id === task.id);
        if (t) await api.put('/tasks/tasks/' + task.id, { ...t, progress });
      },
    });
  }, [tasks, viewMode, loading]);

  const validCount = tasks.filter(t => t.start_date && t.due_date).length;

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontWeight: 700, fontSize: 22, color: '#1a1a2e' }}>📊 Gantt Zaman Çizelgesi</h2>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select value={filterProject} onChange={e => setFilterProject(e.target.value)}
            style={{ padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none', background: 'white' }}>
            <option value="">Tüm Projeler</option>
            {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <div style={{ display: 'flex', background: 'rgba(0,0,0,0.05)', borderRadius: 10, padding: 3 }}>
            {['Day', 'Week', 'Month'].map(mode => (
              <button key={mode} onClick={() => setViewMode(mode)}
                style={{ padding: '6px 14px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 12, background: viewMode === mode ? 'white' : 'transparent', color: viewMode === mode ? '#007aff' : '#6b7280', boxShadow: viewMode === mode ? '0 2px 6px rgba(0,0,0,0.1)' : 'none' }}>
                {mode === 'Day' ? 'Gün' : mode === 'Week' ? 'Hafta' : 'Ay'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {validCount === 0 && !loading ? (
        <div style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 16, padding: 60, textAlign: 'center', color: '#9ca3af' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
          <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Gantt için görev bulunamadı</div>
          <div style={{ fontSize: 13 }}>Başlangıç ve teslim tarihi olan görevler burada görünür.</div>
        </div>
      ) : (
        <div style={{ background: 'rgba(255,255,255,0.9)', borderRadius: 16, padding: 20, boxShadow: '0 4px 20px rgba(0,0,0,0.06)', overflow: 'auto' }}>
          <style>{`
            .gantt .bar { fill: #007aff; }
            .gantt .bar-progress { fill: #5856d6; }
            .gantt .bar-label { fill: white; font-size: 11px; }
            .priority-kritik .bar { fill: #ef4444; }
            .priority-yuksek .bar { fill: #f97316; }
            .priority-normal .bar { fill: #007aff; }
            .priority-dusuk .bar { fill: #9ca3af; }
          `}</style>
          <div ref={ganttRef} />
          <div style={{ display: 'flex', gap: 14, marginTop: 16, flexWrap: 'wrap' }}>
            {Object.entries(PRIORITY_COLORS).map(([key, color]) => (
              <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 12, height: 12, borderRadius: 3, background: color }} />
                <span style={{ fontSize: 12, color: '#6b7280' }}>
                  {key === 'kritik' ? 'Kritik' : key === 'yuksek' ? 'Yüksek' : key === 'normal' ? 'Normal' : 'Düşük'}
                </span>
              </div>
            ))}
            <div style={{ fontSize: 12, color: '#9ca3af', marginLeft: 'auto' }}>{validCount} görev gösteriliyor</div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
